import { useAppState } from 'hooks/useAppState';
import { GiroPaymentManager } from 'types/giroPaymentManagerTypes';

export const useGiroPaymentManager = (): GiroPaymentManager => {
  const { giroPaymentManager } = useAppState();

  return giroPaymentManager;
};
